<template>
  <div>
    <Nav></Nav>
    <b-container fluid>
      <b-row>
        <b-col>
          <h1 v-if="actualGroup.id > 0">Grupo de Extras {{ actualGroup.id + " " + actualGroup.name }}</h1>
          <h1 v-else>Crear Grupo de Extras</h1>
        </b-col>
      </b-row>

      <!-- Section 1: Group Info -->
      <b-card class="mb-3">
        <h3>Informacion del Grupo</h3>
        <b-row>
          <b-col md="6" sm="12">
            <b-form-group label="Nombre:">
              <b-form-input v-model="actualGroup.name" type="text" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-group label="Min Seleccion:">
              <b-form-input v-model.number="actualGroup.min_selection" type="number" min="0" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-group label="Max Seleccion:">
              <b-form-input v-model.number="actualGroup.max_selection" type="number" min="1" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-group label="Ordenacion:">
              <b-form-input v-model.number="actualGroup.ordenation" type="number" required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3" sm="6">
            <b-form-group label="Estado:">
              <b-form-checkbox v-model="actualGroup.status" :value="1" :unchecked-value="0">
                Activo
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-button v-if="actualGroup.id > 0" block variant="success" @click="saveGroup">Guardar</b-button>
            <b-button v-else block variant="success" @click="saveGroup">Crear</b-button>
          </b-col>
        </b-row>
      </b-card>

      <!-- Section 2: Assigned Products -->
      <b-card class="mb-3" v-if="actualGroup.id > 0">
        <h3>Productos Asignados</h3>
        <b-row class="mb-3">
          <b-col md="8">
            <vu-select v-model="newProductId" :options="productOptions" :reduce="x => x.value" label="text" placeholder="Buscar producto para asignar..."></vu-select>
          </b-col>
          <b-col md="4">
            <b-button variant="primary" @click="assignProduct" :disabled="!newProductId">Asignar Producto</b-button>
          </b-col>
        </b-row>
        <b-table small stacked="sm" responsive :items="groupProducts" :fields="fieldsProducts" v-if="groupProducts.length > 0">
          <template #cell(product_id)="data">
            {{ getProductName(data.item.product_id) }}
          </template>
          <template #cell(actions)="data">
            <b-button size="sm" variant="danger" @click="removeProduct(data.item.id)">Quitar</b-button>
          </template>
        </b-table>
        <b-alert v-else show variant="info">No hay productos asignados a este grupo.</b-alert>
      </b-card>

      <!-- Section 3: Items -->
      <b-card class="mb-3" v-if="actualGroup.id > 0">
        <h3>Items del Grupo</h3>
        <b-button class="mb-3" variant="primary" @click="openAddItem()">Agregar Producto</b-button>
        <b-table small stacked="sm" responsive :items="items" :fields="fieldsItems" v-if="items.length > 0">
          <template #cell(product_id)="data">
            {{ getProductName(data.item.product_id) }}
          </template>
          <template #cell(default_selected)="data">
            <b-badge pill v-if="data.item.default_selected" variant="success">SI</b-badge>
            <b-badge pill v-else variant="danger">NO</b-badge>
          </template>
          <template #cell(status)="data">
            <b-badge pill v-if="data.item.status == 1" variant="success">Activo</b-badge>
            <b-badge pill v-else variant="danger">Inactivo</b-badge>
          </template>
          <template #cell(prices)="data">
            <b-button size="sm" variant="info" @click="selectItem(data.item)">Precios</b-button>
          </template>
          <template #cell(actions)="data">
            <b-button-group>
              <b-button size="sm" variant="warning" @click="openEditItem(data.item)">Editar</b-button>
              <b-button size="sm" variant="danger" @click="deleteItem(data.item.id)">Eliminar</b-button>
            </b-button-group>
          </template>
        </b-table>
      </b-card>

      <!-- Section 4: Item Prices -->
      <b-card class="mb-3" v-if="selectedItem">
        <h3>Precios de: {{ getProductName(selectedItem.product_id) }}</h3>
        <b-button class="mb-3" variant="primary" @click="openAddPrice()">Agregar Precio</b-button>
        <b-table small stacked="sm" responsive :items="itemPrices" :fields="fieldsPrices" v-if="itemPrices.length > 0">
          <template #cell(restaurant_area_id)="data">
            {{ data.item.restaurant_area_id ? getAreaName(data.item.restaurant_area_id) : 'Precio por defecto' }}
          </template>
          <template #cell(tax_excempt)="data">
            <b-badge pill v-if="data.item.tax_excempt" variant="success">SI</b-badge>
            <b-badge pill v-else variant="danger">NO</b-badge>
          </template>
          <template #cell(actions)="data">
            <b-button-group>
              <b-button size="sm" variant="warning" @click="openEditPrice(data.item)">Editar</b-button>
              <b-button size="sm" variant="danger" @click="deletePrice(data.item.id)">Eliminar</b-button>
            </b-button-group>
          </template>
        </b-table>
      </b-card>

    </b-container>

    <!-- Modal: Add/Edit Item -->
    <b-modal id="modal-addItem" title="Item del Grupo" @ok="saveItem">
      <b-row>
        <b-col md="12">
          <b-form-group label="Producto:">
            <vu-select v-model="actualItem.product_id" :options="productOptions" :reduce="x => x.value" label="text" placeholder="Buscar producto..."></vu-select>
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Seleccionado por defecto:">
            <b-form-checkbox v-model="actualItem.default_selected">
              Default
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Ordenacion:">
            <b-form-input v-model.number="actualItem.ordenation" type="number"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Estado:">
            <b-form-checkbox v-model="actualItem.status" :value="1" :unchecked-value="0">
              Activo
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Modal: Add/Edit Price -->
    <b-modal id="modal-addPrice" title="Precio del Item" @ok="savePrice">
      <b-row>
        <b-col md="12">
          <b-form-group label="Area:">
            <b-form-select v-model="actualPrice.restaurant_area_id" :options="areaOptions">
              <template #first>
                <b-form-select-option :value="null">Precio por defecto</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12">
          <b-form-group label="Precio:">
            <b-form-input v-model.number="actualPrice.price" type="number" step="0.01"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12">
          <b-form-group label="Precio sin IVA:">
            <b-form-input v-model.number="actualPrice.price_wo_tax" type="number" step="0.01"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4" sm="12">
          <b-form-group label="IVA:">
            <b-form-input v-model.number="actualPrice.tax" type="number" step="0.01"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="6" sm="12">
          <b-form-group label="Exento de IVA:">
            <b-form-checkbox v-model="actualPrice.tax_excempt" :value="1" :unchecked-value="0">
              Exento
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";

export default {
  name: "ProductExtraGroup",
  components: { Nav },
  data() {
    return {
      actualGroup: {
        id: 0,
        name: "",
        min_selection: 0,
        max_selection: 1,
        ordenation: 0,
        status: 1,
        items: [],
        products: [],
      },
      actualItem: {
        id: 0,
        extra_group_id: 0,
        product_id: 0,
        default_selected: false,
        ordenation: 0,
        status: 1,
      },
      actualPrice: {
        id: 0,
        extra_group_item_id: 0,
        restaurant_area_id: null,
        price: 0,
        price_wo_tax: 0,
        tax: 0,
        tax_excempt: 0,
      },
      selectedItem: null,
      newProductId: null,
      products: [],
      restAreas: [],
      items: [],
      itemPrices: [],
      groupProducts: [],
      productOptions: [],
      areaOptions: [],
      fieldsProducts: [
        { key: "product_id", label: "Producto", sortable: true },
        { key: "actions", label: "Acciones" },
      ],
      fieldsItems: [
        { key: "id", label: "ID", sortable: true },
        { key: "product_id", label: "Producto", sortable: true },
        { key: "default_selected", label: "Seleccionado por defecto" },
        { key: "ordenation", label: "Orden", sortable: true },
        { key: "status", label: "Estado" },
        { key: "prices", label: "Precios" },
        { key: "actions", label: "Acciones" },
      ],
      fieldsPrices: [
        { key: "id", label: "ID", sortable: true },
        { key: "restaurant_area_id", label: "Area" },
        { key: "price", label: "Precio", sortable: true },
        { key: "price_wo_tax", label: "Precio sin IVA" },
        { key: "tax", label: "IVA" },
        { key: "tax_excempt", label: "Exento" },
        { key: "actions", label: "Acciones" },
      ],
    };
  },
  mounted() {
    this.loadProducts();
    this.loadRestAreas();
    if (this.$route.params.id) {
      this.actualGroup.id = this.$route.params.id;
      this.loadGroup();
    }
  },
  methods: {
    loadGroup() {
      let that = this;
      axios
        .get("/product/extragroup/" + this.actualGroup.id)
        .then(function (response) {
          that.actualGroup = response.data;
          that.groupProducts = response.data.products || [];
          that.loadItems();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    loadProducts() {
      let that = this;
      axios
        .get("/products")
        .then(function (response) {
          that.products = response.data;
          that.productOptions = response.data
            .sort(function (a, b) {
              return (a.ndescription || "").localeCompare(b.ndescription || "");
            })
            .map(function (p) {
              return { value: p.id, text: p.id + " " + p.ndescription };
            });
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    loadRestAreas() {
      let that = this;
      axios
        .get("/restaurant/areas")
        .then(function (response) {
          that.restAreas = response.data;
          that.areaOptions = response.data.map(function (a) {
            return { value: a.id, text: a.name };
          });
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    getProductName(id) {
      let product = this.products.find(function (p) { return p.id == id; });
      return product ? product.id + " " + product.ndescription : id;
    },
    getAreaName(id) {
      let area = this.restAreas.find(function (a) { return a.id == id; });
      return area ? area.name : id;
    },
    saveGroup() {
      let that = this;
      if (this.actualGroup.id > 0) {
        axios
          .put("/product/extragroup/" + this.actualGroup.id, this.actualGroup)
          .then(function (response) {
            that.actualGroup = response.data;
            that.makeToast("Exito", "Grupo actualizado", "success");
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      } else {
        axios
          .post("/product/extragroup", this.actualGroup)
          .then(function (response) {
            that.makeToast("Exito", "Grupo creado", "success");
            that.$router.push("/product-extra-group/" + response.data.id);
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      }
    },

    // Product Assignments
    assignProduct() {
      if (!this.newProductId) return;
      let that = this;
      axios
        .post("/product/extragroup/" + this.actualGroup.id + "/product", { product_id: this.newProductId })
        .then(function () {
          that.makeToast("Exito", "Producto asignado", "success");
          that.newProductId = null;
          that.loadGroupProducts();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    removeProduct(linkId) {
      if (!confirm("¿Quitar este producto del grupo?")) return;
      let that = this;
      axios
        .delete("/product/extragroup/" + this.actualGroup.id + "/product/" + linkId)
        .then(function () {
          that.makeToast("Exito", "Producto removido", "success");
          that.loadGroupProducts();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    loadGroupProducts() {
      let that = this;
      axios
        .get("/product/extragroup/" + this.actualGroup.id + "/products")
        .then(function (response) {
          that.groupProducts = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },

    // Items
    loadItems() {
      let that = this;
      axios
        .get("/product/extragroup/" + this.actualGroup.id + "/items")
        .then(function (response) {
          that.items = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    openAddItem() {
      this.actualItem = {
        id: 0,
        extra_group_id: this.actualGroup.id,
        product_id: 0,
        default_selected: false,
        ordenation: 0,
        status: 1,
      };
      this.$bvModal.show("modal-addItem");
    },
    openEditItem(item) {
      this.actualItem = Object.assign({}, item);
      this.$bvModal.show("modal-addItem");
    },
    saveItem() {
      let that = this;
      this.actualItem.extra_group_id = this.actualGroup.id;
      if (this.actualItem.id > 0) {
        axios
          .put("/product/extragroup/" + this.actualGroup.id + "/item/" + this.actualItem.id, this.actualItem)
          .then(function () {
            that.makeToast("Exito", "Item actualizado", "success");
            that.loadItems();
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      } else {
        axios
          .post("/product/extragroup/" + this.actualGroup.id + "/item", this.actualItem)
          .then(function () {
            that.makeToast("Exito", "Item creado", "success");
            that.loadItems();
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      }
    },
    deleteItem(id) {
      if (!confirm("¿Estás seguro de eliminar este item?")) return;
      let that = this;
      axios
        .delete("/product/extragroup/" + this.actualGroup.id + "/item/" + id)
        .then(function () {
          that.makeToast("Exito", "Item eliminado", "success");
          that.loadItems();
          if (that.selectedItem && that.selectedItem.id == id) {
            that.selectedItem = null;
            that.itemPrices = [];
          }
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },

    // Prices
    selectItem(item) {
      this.selectedItem = item;
      this.loadPrices();
    },
    loadPrices() {
      let that = this;
      axios
        .get("/product/extragroup/item/" + this.selectedItem.id + "/prices")
        .then(function (response) {
          that.itemPrices = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    openAddPrice() {
      this.actualPrice = {
        id: 0,
        extra_group_item_id: this.selectedItem.id,
        restaurant_area_id: null,
        price: 0,
        price_wo_tax: 0,
        tax: 0,
        tax_excempt: 0,
      };
      this.$bvModal.show("modal-addPrice");
    },
    openEditPrice(price) {
      this.actualPrice = Object.assign({}, price);
      this.$bvModal.show("modal-addPrice");
    },
    savePrice() {
      let that = this;
      this.actualPrice.extra_group_item_id = this.selectedItem.id;
      if (this.actualPrice.id > 0) {
        axios
          .put("/product/extragroup/item/price/" + this.actualPrice.id, this.actualPrice)
          .then(function () {
            that.makeToast("Exito", "Precio actualizado", "success");
            that.loadPrices();
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      } else {
        axios
          .post("/product/extragroup/item/" + this.selectedItem.id + "/price", this.actualPrice)
          .then(function () {
            that.makeToast("Exito", "Precio creado", "success");
            that.loadPrices();
          })
          .catch(function (err) {
            that.makeToast("Error", err.request.response, "danger");
          });
      }
    },
    deletePrice(id) {
      if (!confirm("¿Estás seguro de eliminar este precio?")) return;
      let that = this;
      axios
        .delete("/product/extragroup/item/price/" + id)
        .then(function () {
          that.makeToast("Exito", "Precio eliminado", "success");
          that.loadPrices();
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },

    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
